import React, {useState, Suspense} from 'react'
import PicCont from './PicCont'
import lineToBr from './lineToBr'
import Snippets from './Snippets'
import { helper } from '../utilities/helper';
import { TooltipIcon } from './Components';
import Button from './Button';
import { AiOutlineShoppingCart } from '@react-icons/all-files/ai/AiOutlineShoppingCart';
import { FaExclamationTriangle } from '@react-icons/all-files/fa/FaExclamationTriangle';
import LinkWrap from './LinkWrap';
import { FiTruck } from '@react-icons/all-files/fi/FiTruck';
import { TiCancel } from '@react-icons/all-files/ti/TiCancel';
import Clickable from './Clickable';
import dynamic from 'next/dynamic';
import {  Spinner } from './Components';
import { getWorkingPackage } from '../store/slices/entities/packages';
import { getMedia, getUser, getUserGeo, purchaseAddItem } from '../store/slices/user';
import { useDispatch, useSelector } from 'react-redux';
import * as gtag from '../lib/gtag'
import { getWorkingOrder } from '../store/slices/entities/orders';
import { useRouter } from 'next/router';
import AudioAction from './design-system/audio/AudioAction';
import styles from './design-system/audio/AudioProductRow.module.scss';
import { resolveShoppingMarket } from '../utilities/fulfillmentMarket';

const AddUnits = dynamic(() => import('./AddUnits'), { suspense: true })
const ListProduct = ({p, index,addToCartItems, openRentalStart, ui, unifiedEligible = false}) => {
    let [view, setView] = useState(false)
    let dispatch = useDispatch()
    let {pathname, push} = useRouter()
    let workingPackage = useSelector(getWorkingPackage)
    let order = useSelector(getWorkingOrder)
    let purchase_order = order?.request_type === 'purchase'

    let {cart, user} = useSelector(getUser)
    let description = p?.description?.replace(/^\s+|\s+$/g, '')?.trim()
  let geo = useSelector(getUserGeo)
    let orlando = resolveShoppingMarket({geo, order, pathname}) === 'Orlando'
    let gView = () => {
      try {
        gtag.event({action:'view_item', label: 'sales',

        category: 'orders',

        currency: "USD",
        items: [{
          item_id: p?._id,
          item_name: p?.name,
          index: 0,
          item_category: p.categories[0]?.split('/')?.[0],
          item_category2: p.categories[0]?.split('/')?.[1],
          price: p?.price?.rental,
          quantity: 1
        }]

      })
      } catch(err) {
        console.log(err)
      }
    }

    let estimated_del =p?.price.rental * ((p?.difficulty / 10)) *1.35
    let req_two = p.requires_two
    let show_min = false

    if(estimated_del < (req_two ? 240 : 120)) show_min =req_two ? 240 : 120

    const chooseDates = event => {
      event.preventDefault()
      openRentalStart?.(p)
    }


  return <div className={`listProduct ${ui === 'v2' ? styles.root : ''} ${index % 2 === 0 ? 'even': 'odd'}`}>
    {/* <LinkWrap href={`/products/${helper.makeUrl(p.name)}`} >
    <strong className="title ONLYPHONE">{p.name}</strong>
        </LinkWrap> */}

  <div className='productRow'>
    {ui === 'v2' ? <AudioAction mode='productMedia' href={`/products/${helper.makeUrl(p.name)}`} onClick={gView} wrapContent={false}>
      <PicCont picture={p.picture} width={200} height={200} />
       <div>Details &amp; Pictures</div>
    </AudioAction> : <LinkWrap href={`/products/${helper.makeUrl(p.name)}`} onClick={gView} >
      <PicCont picture={p.picture} width={200} height={200} />
       <div className='link '>Details & Pictures</div>
    </LinkWrap>}

    <div className="infoCol">
    {ui === 'v2' ? <AudioAction mode='unstyled' href={`/products/${helper.makeUrl(p.name)}`} onClick={gView} wrapContent={false}>
        <strong className="title">{p.name}</strong>
        </AudioAction> : <LinkWrap href={`/products/${helper.makeUrl(p.name)}`} onClick={gView} >
        <strong className="title">{p.name}</strong>
        </LinkWrap>}
        <p>{lineToBr(helper.shortText( view?  description :description.split('\n')?.[0] , view? 100: 30))}


          </p>
          {(description.split(' ')?.length >30 || description?.includes('\n'))  && (ui === 'v2'
            ? <AudioAction mode='text' ariaExpanded={view} onClick={()=> setView(!view)}>View {view ? 'Less' : 'More'}</AudioAction>
            : <Clickable onClick={()=> setView(!view)} >View {view ? 'Less' : 'More'}</Clickable>)}
        <Snippets snippets={p.snippets} />
    </div>
    </div>
    <div className="priceCol">
        <strong className="price">{ p.only_purchase || (purchase_order && p?.price?.map) ? '' :'Rental'} Price: {helper.formatPrice(p.only_purchase || (purchase_order && p?.price?.map) ? (p.price?.map || p.price?.purchase) :  p.price.rental)} {p.only_purchase || (purchase_order && p?.price?.map) ? '' :'/24h'}</strong>
      {(!p.only_purchase  && (!purchase_order || !p?.price?.map) ) &&  <strong className="delivery"> <TooltipIcon>We offer full delivery, installation, breakdown and technical assistance 24 hours 7 days per week including holidays. We service all south florida from Orlando to Key West. Our technicians will deliver the equipment at a time of your choice, install it according to your specifications and instruct you on how to use the equipment. Delivery and installation prices are calculated based on your location and delivery times, please click Schedule Deliver to get an exact price.</TooltipIcon> <div className="estimatedDel">Estimated Delivery and Installation: {helper.formatPrice(estimated_del)}{show_min ? <div className='minDel'>({helper.formatPrice(show_min)} min delivery)</div> : null}</div> </strong>}
     {!p.orlando && orlando && <strong className="delivery warning"><TooltipIcon icon={<FaExclamationTriangle/>}>This item is stocked in Miami. Adding it to an Orlando order changes fulfillment to Miami and may add one travel fee for the order.</TooltipIcon> Miami warehouse item · travel may apply</strong>}
        { workingPackage ?
         <div className='buttons buttonUnits'>
             <Suspense fallback={<Spinner size='tiny' />}> <AddUnits bigButton ui={ui} subCat pack selectedUnits={workingPackage.components.find(item => item.product.name === p?.name)?.units || 0} product={p} /></Suspense>
             </div>:
             cart.items?.length ?
            purchase_order ?
            <div className='buttons buttonUnits'>
         {ui === 'v2' ? <AudioAction mode='primary' fullWidth onClick={() => (p.only_purchase || p.price.map)  ?  dispatch(purchaseAddItem({product:p, units: 1, push, orlando, user, pathname }))  : addToCartItems(p)} disabled={!p.allow_pickup || (!p.orlando && orlando)}> {!p.allow_pickup || (!p.orlando && orlando) ? <TiCancel/>  :<AiOutlineShoppingCart />} {!p.allow_pickup || (!p.orlando && orlando) ? 'Pickup Not Available' : (p.only_purchase || p.price.map) ? 'Purchase Product' : 'Rent Product'}</AudioAction> : <Button onClick={() => (p.only_purchase || p.price.map)  ?  dispatch(purchaseAddItem({product:p, units: 1, push, orlando, user, pathname }))  : addToCartItems(p)}  disabled={!p.allow_pickup || (!p.orlando && orlando)} className={`btn-3 highLight ${p.allow_pickup ? 'highLight' : 'disabled' } `}> {!p.allow_pickup || (!p.orlando && orlando) ? <TiCancel/>  :<AiOutlineShoppingCart />} {!p.allow_pickup || (!p.orlando && orlando) ? 'Pickup Not Available' : (p.only_purchase || p.price.map) ? 'Purchase Product' : 'Rent Product'}</Button>}

         </div>
            :
             <div className='buttons buttonUnits'>
                {ui === 'v2' ? <AudioAction mode='secondary' fullWidth onClick={() => addToCartItems(p, true)}><FiTruck />Change to Delivery</AudioAction> : <Button onClick={() => addToCartItems(p, true)} className={`btn-3 `}><FiTruck />Change to Delivery</Button>}
             <Suspense fallback={<Spinner size='tiny' />}> <AddUnits bigButton ui={ui} selectedUnits={cart.items.find(item => item.product.name === p?.name)?.units || 0} product={p} /></Suspense>
             </div>
             :

        p.only_purchase ? <div className="buttons">
          {ui === 'v2' ? <AudioAction mode='secondary' fullWidth onClick={() => addToCartItems(p, true)}><FiTruck />{!p.orlando && orlando ? 'Ship from Miami' : 'Schedule Delivery'}</AudioAction> : <Button onClick={() => addToCartItems(p, true)} className='btn-3'><FiTruck />{!p.orlando && orlando ? 'Ship from Miami' : 'Schedule Delivery'}</Button>}
          {ui === 'v2' ? <AudioAction mode='primary' fullWidth onClick={() => dispatch(purchaseAddItem({product:p, units: 1, push, orlando, user, pathname }))} disabled={!p.allow_pickup || (!p.orlando && orlando)}>{!p.allow_pickup || (!p.orlando && orlando) ? <TiCancel/> : <AiOutlineShoppingCart />}{!p.allow_pickup || (!p.orlando && orlando) ? 'Pickup Not Available' : 'Purchase Product'}</AudioAction> : <Button onClick={() => dispatch(purchaseAddItem({product:p, units: 1, push, orlando, user, pathname }))} disabled={!p.allow_pickup || (!p.orlando && orlando)} className={`btn-3 highLight ${p.allow_pickup ? 'highLight' : 'disabled'}`}>{!p.allow_pickup || (!p.orlando && orlando) ? <TiCancel/> : <AiOutlineShoppingCart />}{!p.allow_pickup || (!p.orlando && orlando) ? 'Pickup Not Available' : 'Purchase Product'}</Button>}
        </div> : <div className="buttons">
          <span className={ui === 'v2' ? styles.entryHint : 'rentOnlineHint'}>Warehouse pickup or delivery &amp; setup</span>
          {ui === 'v2'
            ? <AudioAction href={`/products/${helper.makeUrl(p.name)}#rent-online`} mode='primary' fullWidth onClick={chooseDates}><AiOutlineShoppingCart />Choose Dates &amp; Rent Online</AudioAction>
            : <Button href={`/products/${helper.makeUrl(p.name)}#rent-online`} onClick={chooseDates} className='btn-3 highLight'><AiOutlineShoppingCart />Choose Dates &amp; Rent Online</Button>}

          {/* Legacy two-CTA entry retained for reference while the new entry is tested.
          {ui === 'v2' ? <AudioAction mode='secondary' fullWidth onClick={() => addToCartItems(p, true)}><FiTruck />{!p.orlando && orlando ? 'Ship from Miami' : unifiedEligible ? 'Add with delivery & setup' : 'Schedule Delivery'}</AudioAction> : <Button onClick={() => addToCartItems(p, true)} className='btn-3'><FiTruck />{!p.orlando && orlando ? 'Ship from Miami' : unifiedEligible ? 'Add with delivery & setup' : 'Schedule Delivery'}</Button>}
          {ui === 'v2' ? <AudioAction mode='primary' fullWidth onClick={() => addToCartItems(p)} disabled={!p.allow_pickup || (!p.orlando && orlando)}>{!p.allow_pickup || (!p.orlando && orlando) ? <TiCancel/> : <AiOutlineShoppingCart />}{!p.allow_pickup || (!p.orlando && orlando) ? 'Pickup Not Available' : unifiedEligible ? 'Add for warehouse pickup' : 'Add to Rental'}</AudioAction> : <Button onClick={() => addToCartItems(p)} disabled={!p.allow_pickup || (!p.orlando && orlando)} className={`btn-3 highLight ${p.allow_pickup ? 'highLight' : 'disabled'}`}>{!p.allow_pickup || (!p.orlando && orlando) ? <TiCancel/> : <AiOutlineShoppingCart />}{!p.allow_pickup || (!p.orlando && orlando) ? 'Pickup Not Available' : unifiedEligible ? 'Add for warehouse pickup' : 'Add to Rental'}</Button>}
          */}
        </div>}
    </div>

  </div>
}

export default ListProduct
